<template>
  <main class="main-content">
    <!-- 更新日志 -->
    <section class="section" id="changelog">
      <div class="section-header">
        <h1>更新日志</h1>
        <p>了解API接口的最新功能和改进</p>
      </div>

      <div class="api-reference">
        <div class="api-item">
          <h3>v1.2.0 - 2024年5月15日</h3>
          <p class="api-description">新增功能和完善</p>
          <ul>
            <li>新增支付接口，支持企业向多个银行发起支付交易</li>
            <li>优化流水查询接口，增加交易对手信息字段</li>
            <li>增加数据加密传输选项，提升数据安全性</li>
            <li>修复已知问题，提升接口稳定性</li>
          </ul>
        </div>

        <div class="api-item">
          <h3>v1.1.0 - 2024年4月10日</h3>
          <p class="api-description">功能增强</p>
          <ul>
            <li>新增每日余额查询接口，支持历史余额数据获取</li>
            <li>优化签约状态查询接口，增加详细状态信息</li>
            <li>增加银行支持列表，新增3家银行支持</li>
            <li>改进错误处理机制，提供更详细的错误信息</li>
          </ul>
        </div>

        <div class="api-item">
          <h3>v1.0.0 - 2024年3月1日</h3>
          <p class="api-description">初始版本发布</p>
          <ul>
            <li>发布基础API接口：客户管理、签约管理、流水查询</li>
            <li>支持10家主流银行的流水数据获取</li>
            <li>提供完整的API文档和SDK支持</li>
            <li>实现安全认证和数据加密机制</li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
// 更新日志组件不需要额外的逻辑
</script>

<style scoped>
.section {
  margin-bottom: 3rem;
}

.section-header {
  margin-bottom: 1.5rem;
}

.section-header h1 {
  font-size: 2rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.section-header p {
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.api-reference {
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.api-item {
  border-bottom: 1px solid var(--border);
  padding: 1.5rem;
}

.api-item:last-child {
  border-bottom: none;
}

.api-item h3 {
  font-size: 1.25rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.api-description {
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

ul {
  padding-left: 1.5rem;
}

li {
  margin-bottom: 0.5rem;
  color: var(--text-secondary);
}
</style>
